// removed by extract-text-webpack-plugin
module.exports = {"campaign":"campaign__TjntI"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Campaign/index.css
// module id = 1581
// module chunks = 0